import { useState, useContext } from "react";
import bgVideo from "../assets/video2.mp4";
import { ThemeContext } from "../context/ThemeContext";

export default function Contact() {
  const { theme } = useContext(ThemeContext);

  const [formData, setFormData] = useState({
    name: "",
    domisili: "",
    services: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // --------------------------------------------------------
  // REPLACED BACKEND → USING WEB3FORMS (NO BACKEND NEEDED)
  // --------------------------------------------------------
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);
    setLoading(true);

    try {
      const data = new FormData();
      data.append("access_key", "5a8a4242-0ec7-4564-86ef-38d6dfe97c03"); // your key
      data.append("name", formData.name);
      data.append("domisili", formData.domisili);
      data.append("services", formData.services);
      data.append("message", formData.message);

      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: data,
      });

      const result = await res.json();

      if (result.success) {
        setStatus({
          type: "success",
          msg: "Terima kasih! Pesan kamu sudah terkirim.",
        });
        setFormData({
          name: "",
          domisili: "",
          services: "",
          message: "",
        });
      } else {
        setStatus({
          type: "error",
          msg: result.message || "Gagal mengirim pesan.",
        });
      }
    } catch (err) {
      setStatus({ type: "error", msg: "Terjadi kesalahan saat mengirim." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      className={`min-h-screen flex flex-col transition-all duration-500 ${
        theme === "light" ? "bg-gray-50" : "bg-slate-900"
      }`}
    >
      {/* Hero Section */}
      <div className="relative w-full h-72 md:h-96 flex items-center justify-center text-center overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src={bgVideo} type="video/mp4" />
        </video>

        <div
          className={`absolute inset-0 ${
            theme === "light"
              ? "bg-black/50"
              : "bg-black/70 backdrop-blur-sm"
          }`}
        ></div>

        <div className="relative z-10 max-w-2xl px-6">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
            We Are Here For Your Business
          </h1>
          <p className="text-white text-lg leading-relaxed">
            We provide solutions designed to help you grow, innovate, and
            succeed in a global market.
          </p>
        </div>
      </div>

      {/* Contact Form */}
      <div className="flex flex-col items-center px-6 py-16 flex-1">
        <div
          className={`w-full max-w-2xl shadow-lg rounded-2xl p-8 transition duration-500 ${
            theme === "light" ? "bg-white" : "bg-slate-800 text-white"
          }`}
        >
          <h2
            className={`text-3xl font-bold text-center mb-6 ${
              theme === "light" ? "text-gray-800" : "text-white"
            }`}
          >
            Contact Us
          </h2>

          {status && (
            <div
              className={`mb-4 rounded-lg px-4 py-3 text-sm ${
                status.type === "success"
                  ? "bg-green-50 text-green-700"
                  : "bg-red-50 text-red-700"
              }`}
            >
              {status.msg}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Name */}
            <div>
              <label
                className={`block text-sm font-medium ${
                  theme === "light" ? "text-gray-700" : "text-gray-200"
                }`}
              >
                Name
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className={`mt-1 block w-full rounded-lg px-4 py-2 border focus:ring-2 focus:ring-blue-500 focus:outline-none transition ${
                  theme === "light"
                    ? "bg-white border-gray-300 text-black"
                    : "bg-slate-700 border-slate-600 text-white placeholder-gray-300"
                }`}
              />
            </div>

            {/* Email */}
            <div>
              <label
                className={`block text-sm font-medium ${
                  theme === "light" ? "text-gray-700" : "text-gray-200"
                }`}
              >
                Email
              </label>
              <input
                type="text"
                name="domisili"
                value={formData.domisili}
                onChange={handleChange}
                required
                className={`mt-1 block w-full rounded-lg px-4 py-2 border focus:ring-2 focus:ring-blue-500 focus:outline-none transition ${
                  theme === "light"
                    ? "bg-white border-gray-300 text-black"
                    : "bg-slate-700 border-slate-600 text-white placeholder-gray-300"
                }`}
              />
            </div>

            {/* Services */}
            <div>
              <label
                className={`block text-sm font-medium ${
                  theme === "light" ? "text-gray-700" : "text-gray-200"
                }`}
              >
                Choose Services
              </label>
              <select
                name="services"
                value={formData.services}
                onChange={handleChange}
                required
                className={`mt-1 block w-full rounded-lg px-4 py-2 border focus:ring-2 focus:ring-blue-500 focus:outline-none transition ${
                  theme === "light"
                    ? "bg-white border-gray-300 text-black"
                    : "bg-slate-700 border-slate-600 text-white"
                }`}
              >
                <option value="">-- Choose Services --</option>
                <option value="Global Technology Consulting">
                  Global Technology Consulting
                </option>
                <option value="Strategic Supply Network">
                  Strategic Supply Network
                </option>
                <option value="Digital Infrastructure Provisioning">
                  Digital Infrastructure Provisioning
                </option>
                <option value="Modern Workflow Empowerment">
                  Modern Workflow Empowerment
                </option>
                <option value="Enterprise Hardware Provisioning">
                  Enterprise Hardware Provisioning
                </option>
                <option value="Multisector Resource Enablement">
                  Multisector Resource Enablement
                </option>
              </select>
            </div>

            {/* Message */}
            <div>
              <label
                className={`block text-sm font-medium ${
                  theme === "light" ? "text-gray-700" : "text-gray-200"
                }`}
              >
                Messages / Problems
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="4"
                className={`mt-1 block w-full rounded-lg px-4 py-2 border focus:ring-2 focus:ring-blue-500 focus:outline-none transition ${
                  theme === "light"
                    ? "bg-white border-gray-300 text-black"
                    : "bg-slate-700 border-slate-600 text-white placeholder-gray-300"
                }`}
              />
            </div>

            <div className="text-center">
              <button
                type="submit"
                disabled={loading}
                className={`px-6 py-3 text-white font-semibold rounded-lg shadow-md transition ${
                  loading
                    ? "bg-blue-400 cursor-not-allowed"
                    : "bg-blue-600 hover:bg-blue-700"
                }`}
              >
                {loading ? "Sending..." : "Send Message"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
